import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Radio} from './luci-radio.model';

@Component({
  selector: 'luci-radio',
  templateUrl: './luci-radio.component.html',
  styleUrls: ['./luci-radio.component.scss']
})
export class LuciRadioComponent implements OnInit {

  @Input() radioLabel = '';
  @Input() count: Radio[] = [];
  @Input() highlight = '';
  @Input() layout = '';
  @Input() inlineLabel = false;
  @Output() radioChecked: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {

  }

  handleChange(item: any, index: number) {
    this.count.map((x, i) => {
      x.checked = i === index;
    });
    this.radioChecked.emit({index, data: this.count});
  }

}
